  import Vue from 'vue'
  import Router from 'vue-router'
  // import Home from './views/Home.vue'
  
  Vue.use(Router)
  
  export default new Router({
      mode: 'history',
      base: process.env.BASE_URL,
      routes: [
          {
              path: '/',
              name: 'about',
              alias: '/about',
              component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
          },
          // {
          //     path: '/about',
          //     name: 'about',
          //     // component: Home
          //     component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
          // },
          {
              path: '/docs',
              name: 'docs',
              component: () => import(/* webpackChunkName: "docs" */ './views/Documents.vue')
          },
          {
              path: '/events',
              name: 'events',
              component: () => import(/* webpackChunkName: "events" */ './views/Events.vue')
          },
          {
              path: '/reviews',
              name: 'reviews',
              component: () => import(/* webpackChunkName: "reviews" */ './views/Reviews.vue')
          },
          {
              path: '/admin/texts',
              name: 'adminTexts',
              component: () => import(/* webpackChunkName: "admin-texts" */ './views/AdminTexts.vue')
          },
          {
              path: '/admin/staff',
              name: 'adminStaff',
              component: () => import(/* webpackChunkName: "admin-staff" */ './views/AdminStaff.vue')
          },
      ],
    // NOTE: Do not call Vuetify goTo here.
    // At this stage elements referenced by `to.hash` may not be rendered yet (async data, lazy views),
    // which produced noisy errors like:
    //   Error: Target element "..." not found
    // We handle hash scrolling inside the target views after render (About/Documents).
    scrollBehavior(to, from, savedPosition) {
      if (savedPosition) return savedPosition
      if (to.hash) return false
      return { x: 0, y: 0 }
    },
  })
  